import React from 'react';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';

const VendorInformationTab = ({ 
  register, 
  errors, 
  watch, 
  setValue, 
  vendors,
  inputClassName 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mt-3">
      <div className="px-6 py-4  from-blue-50 to-indigo-50 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center">
          <BuildingStorefrontIcon className="h-6 w-6 mr-2 text-[#009efb]" />
          Vendor Information
        </h2>
      </div>
      <div className="p-6 space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">Purchase Description</label>
          <textarea
            {...register('purchase_description')}
            rows="4"
            className={`${inputClassName} ${
              errors.purchase_description ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
            }`}
            placeholder="Enter purchase description"
          />
          {errors.purchase_description && (
            <p className="mt-1 text-sm text-red-600">{errors.purchase_description.message}</p>
          )}
        </div>
        
        <div className="space-y-6">
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Primary Vendor</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Vendor Name</label>
                <select
                 
                  {...register('primary_vendor_id')}
                  className={`${inputClassName} ${
                    errors.primary_vendor_id ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                  }`}
                  value={watch('primary_vendor_id') || ''}
                  placeholder="Enter vendor name"
                >
                  <option value="">Select Vendor</option>
                  {vendors?.data?.map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </option>
                  ))}
                  </select>              
                {errors.primary_vendor_id && (
                  <p className="mt-1 text-sm text-red-600">{errors.primary_vendor_id.message}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Purchase Price</label>
                <input
                  type="number"
                  {...register('primary_vendor_purchase_price')}
                  className={`${inputClassName} ${
                    errors.primary_vendor_purchase_price ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                  }`}
                  
                  placeholder="0.00"
                />
                {errors.primary_vendor_purchase_price && (
                  <p className="mt-1 text-sm text-red-600">{errors.primary_vendor_purchase_price.message}</p>
                )}
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Secondary Vendor</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Vendor Name</label>
                <select
                  
                  {...register('secondary_vendor_id')}
                  className={`${inputClassName} ${
                    errors.secondary_vendor_id ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                  }`}
                  value={watch('secondary_vendor_id') || ''}
                  placeholder="Enter vendor name"
                >
                  <option value="">Select Vendor</option>
                  {vendors?.data?.map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </option>
                  ))}
                  </select>              
                {errors.secondary_vendor_id && (
                  <p className="mt-1 text-sm text-red-600">{errors.secondary_vendor_id.message}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Purchase Price</label>
                <input
                  type="number"
                  {...register('secondary_vendor_purchase_price')}
                  className={`${inputClassName} ${
                    errors.secondary_vendor_purchase_price ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                  }`}
                  placeholder="0.00"
                />
                {errors.secondary_vendor_purchase_price && (
                  <p className="mt-1 text-sm text-red-600">{errors.secondary_vendor_purchase_price.message}</p>
                )}
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Tertiary Vendor</h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Vendor Name</label>
                <select
                  
                  {...register('tertiary_vendor_id')}
                  className={`${inputClassName} ${
                    errors.tertiary_vendor_id ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                  }`}
                  value={watch('tertiary_vendor_id') || ''}
                  placeholder="Enter vendor name"
                >
                  <option value="">Select Vendor</option>
                  {vendors?.data?.map((vendor) => (
                    <option key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </option>
                  ))}
                  </select>              
                {errors.tertiary_vendor_id && (
                  <p className="mt-1 text-sm text-red-600">{errors.tertiary_vendor_id.message}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Purchase Price</label>
                <input
                  type="number"
                  {...register('tertiary_vendor_purchase_price')}
                  className={`${inputClassName} ${
                    errors.tertiary_vendor_purchase_price ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''
                  }`}
                  placeholder="0.00"
                />
                {errors.tertiary_vendor_purchase_price && (
                  <p className="mt-1 text-sm text-red-600">{errors.tertiary_vendor_purchase_price.message}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorInformationTab; 